import { Col, Container, Row, media } from 'styled-bootstrap-grid';
import { Helmet } from "react-helmet";
import PageTitle from "../../../PageTitle/components/PageTitle";
import React, { Fragment } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import PageNavigation from "../../../PageNavigation/components/PageNavigation";
import GetInTouch from "../../../GetInTouch/components/GetInTouch";
import ViewMoreLink from "../../../ViewMoreLink/components/ViewMoreLink";

const Img = styled.img`
  width: 100%;
`;
const H3 = styled.h3`
  font-weight: 400;
  font-size: 1.7rem;
  margin: 0 0 1rem;
`;
// const InfoTag = styled.p`
//   font-size: 1rem;
//   font-weight: 400;
//   text-transform: uppercase;
//   letter-spacing: 0.2rem;
//   color: #717476;
//   margin: 0 0 0.5rem;
// `;
const P = styled.p`
  color: #717476;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 2.5rem;
`;
const StyledRow = styled(Row)`
  padding-top: 4rem;
  padding-bottom: 4rem;
`;
const StyledCol = styled(Col)`
  margin-bottom: 4rem;
  
  ${media.lg`
    margin-bottom: 0;
  `}
`;

const IndustryTagWrap = styled.div`
  margin-bottom: 4rem;
`;
const IndustryTag = styled.div`
  display: inline-block;
  padding: 0 2rem;
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  margin-right: 1rem;
  height: 3rem;
  border-radius: 2rem;
  text-align: center;
  font-size: 0.8rem;
  letter-spacing: 0.2rem;
  line-height: 3rem;
  text-transform: uppercase;
`;

const ServiceList = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  border-top: 1px solid #d7d7d7;
`;
const ServiceItem = styled.li`
  display: block;
  border-bottom: 1px solid #d7d7d7;
  padding: 1rem;
`;
const ServiceTag = styled.p`
  font-size: 1rem;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  color: #717476;
  margin: 0;
`;
const ServiceName = styled.p`
  color: #212529;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0;
`;

const LightWrap = styled.div`
  background: #fff;
  padding: 4rem 0;
`;
const TransparentWrap = styled.div`
  padding: 4rem 0;
`;
const NavCol = styled(Col)`
  font-weight: bold;
  margin-top: 1rem;
  margin-bottom: 2rem;
  text-align: center;
`;
const NavSpan = styled.span`
  font-size: 0.8rem;
  padding: 0 2rem;
  vertical-align:top;
`;

const VerizonHum = (props) => {
  return <Fragment>
    <Helmet>
      <meta name="description" content=""/>
      <title>Case Study: Hum by Verizon | RMG</title>
      <link rel="canonical" href={'https://www.rmgmedia.com/portfolio/' + props.match.params.caseStudy}/>
    </Helmet>
    <PageTitle heading="Case Study"
               subHeading="Hum by Verizon"
    />
    <Container fluid>
      <Row>
        <Col col={12} noGutter={true}>
          <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/verizon_hero.png" />
        </Col>
      </Row>
    </Container>
    <Container>
      <StyledRow>
        <StyledCol col={12} lg={6}>
          <IndustryTagWrap>
            <IndustryTag>Automotive</IndustryTag>
            <IndustryTag>Technology</IndustryTag>
            <IndustryTag>Communications</IndustryTag>
          </IndustryTagWrap>
          <H3>
            About Hum by Verizon
          </H3>
          <P>
            Hum by Verizon is the premiere 4G LTE car solution for automotive needs. Hum's app allows users to check fuel status, receive maintenance reminders, connect to certified mechanics, provide locations for roadside assistance, automatically call EMS in response to a crash, and much more. By leveraging Google Assistant, Hum lets drivers engage with their car in new ways, asking questions like "when is my next oil change?" and "how far am I from the nearest gas station?"
          </P>
          <P>
            Verizon partnered with RMG to bring the Hum ecommerce experience online, architect and integrate workflows across dozens of teams, and relentlessly test their data processing. The result for Verizon was allowing consumers to purchase the products they need to hit the road with confidence.
          </P>
        </StyledCol>
        <Col col={12} lgOffset={2} lg={4}>
          <H3>
            How We Helped
          </H3>
          <ServiceList>
            <ServiceItem>
              <ServiceTag>Development</ServiceTag>
              <ServiceName>B2C & B2B Implementation</ServiceName>
              <ServiceName>Data Engineering</ServiceName>
              <ServiceName>Headless Commerce</ServiceName>
              <ServiceName>Release Cadence Management</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Devops</ServiceTag>
              <ServiceName>Application &amp; Infrastructure Support</ServiceName>
              <ServiceName>Systems Architecture</ServiceName>
            </ServiceItem>
            <ServiceItem>
              <ServiceTag>Quality Assurance</ServiceTag>
              <ServiceName>API Testing</ServiceName>
              <ServiceName>Functional Testing</ServiceName>
              <ServiceName>Load &amp; Performance Testing</ServiceName>
              <ServiceName>Regression Testing</ServiceName>
            </ServiceItem>
          </ServiceList>
        </Col>
      </StyledRow>
    </Container>
    <LightWrap>
      <Container>
        <Row>
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*  <div><P>As their selection of bags and options continued to grow, Rickshaw partnered with RMG to streamline their online brand experience make it feel like it does in-store. To bring this level of customization online, RMG first replatformed Rickshaw from Magento 1 to Magento 2. During the data migration, RMG made updates to the infrastructure responsible for storing product and customer data, increasing security and functional reliability. These backend updates also allow Rickshaw to rapidly iterate on designs and store their new creations as product/option variations, greatly reducing the time-to-market for new offerings.</P></div>*/}
          {/*  <div><P>This feature immediately gave Rickshaw Bags a huge return on their investment by allowing them to remain open as an essential business and produce facemasks during the COVID-19 pandemic, increasing their pageviews and conversation rate by over 400% and their revenue by almost 500%.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/600x600" /></div>*/}
          {/*  <div><P>After transforming Rickshaw's core digital experience, the same treatment was applied to the rest of the business by adding new shipping methods and options, upgrading their invoice processing, and revamping their blog. Together, these changes help Rickshaw scale their business as their options continue to expand and attract new audiences through their strong content-to-commerce funnel. By working with RMG, Rickshaw Bagworks was able to bring their renowned in-store experience online and expand their reach well beyond their San Francisco storefront.</P></div>*/}
          {/*</Col>*/}
          {/*<Col col={12} lg={6}>*/}
          {/*  <div><P>At the core of Rickshaw's brand experience is the ability to customize a bag's flap, body, inner lining, bindings, buckles, labels, and straps, each of which comes in multiple colors and fabrics. Because of their extraordinary selection, Rickshaw staff's knowledgeable designers to help customers build the best bags based on their needs. In addition, Rickshaw designs and manufactures many custom fabrics, which greatly expands the audiences and applications their products cater to.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/800x1000" /></div>*/}
          {/*  <div><P>On the frontend, RMG built a specialized product customizer which allowed for multiple interacting filters, such as part color and fabric. This customizer also allows customers to make unique, personalized color variations which can be applied across all of Rickshaw's products. In addition, RMG redesigned Rickshaw's entire customer journey to be mobile-first, allowing customers to navigate the customization process with ease regardless of the device they use. As part of this redesign, RMG restyled most of the imagery across the site, even adding support for moving GIF images. We also streamlined Rickshaw's product, catalog, cart, and checkout pages to minimize friction and provide better responsiveness.</P></div>*/}
          {/*  <div><Img src="https://via.placeholder.com/1600x900" /></div>*/}
          {/*</Col>*/}
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/verizon_img_01.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>As one of the largest telecommunications companies on Earth, Verizon needs no introduction. One product line developed by the company that you might not be familiar with is Hum, Verizon's mobile-connected OBD2 reader that relays car diagnostics and information ot an app, as well as emergency services when needed. Hum provides users with on-demand access to a hotline of mechanics, roadside assistance, vehicle locations, speed and boundary alerts, driving history, and a wide variety of other features. Customers can purchase an additional Bluetooth speaker for better hands-free calling that also acts as a Wi-Fi hostspot, keeping drivers connected while they're on the go.</P>
            <P>Verizon partnered with RMG to guide their technical vision, coordinate and optimize data flows across many APIs and project teams, and streamline the product checkout frontend experience.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>When collaborating with many teams - each with their own conventions, processes, tools, and test environments - it can be easy to get bogged down. RMG helped Verizon's teams adopt best practices for code archiving, tagging, revision control, deployment, and testing, which greatly reduced deployment times and increased overall code reliability. By implementing strong version control and adopting RMG's release workflow and development tools, Verizon's management could better associate releases to their feature roadmap and long-term plans for Hum.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/verizon_img_02.png" />
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <LightWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/verizon_img_03.png" />
          </Col>
          <Col col={12} lg={6}>
            <P>As RMG's relationship with Verizon grew, we were asked to manage the coordination between Verizon's teams and tools. RMG standardized processes, data architectures, APIs, and integration tests across the project while remaining compliant with Verizon's rigorous data policies and security standards. By moving Verizon's teams to Apiary, a suite of tools focused on API design, testing, documentation, and iteration, RMG greatly increased testing efficiency and release cadence of multi-teams deployments. These changes greatly improved pace, scope, and results of Verizon's joint interoperability testing (JIT) and systems interoperability testing (SIT) across cars.</P>
          </Col>
        </Row>
      </Container>
    </LightWrap>
    <TransparentWrap>
      <Container>
        <Row>
          <Col col={12} lg={6}>
            <P>In addition to standardizing their development tools, processes, and tests, RMG lead the effort to integrate Verizon's custom data architecture with Hum's checkout experience using Magento. RMG's frontend designs and integrations greatly streamlined the checkout process for the customer while keeping track of the links between specific Hum devices and Verizon's customer accounts. The end result was a smooth and streamlined checkout experience that connected Verizon's customers with the solutions they need to hit the road with confidence.</P>
          </Col>
          <Col col={12} lg={6}>
            <Img src="https://storage.googleapis.com/qa-rmgmediacom-images/CaseStudy/verizon_img_04.png" />
          </Col>
        </Row>
      </Container>
    </TransparentWrap>
    <Container>
      <Row>
        <NavCol col={12}>
          <ViewMoreLink textColor="#000" arrowWidth='0.6rem' directionReversed
                        to={`/portfolio/charming-charlie`}
                        buttonText="Charming Charlie" />
          <NavSpan>/</NavSpan>
          <ViewMoreLink textColor="#000" arrowWidth='0.6rem' to={`/portfolio/no-compromise-gaming`}
                        buttonText="No Compromise Gaming" />
        </NavCol>
      </Row>
    </Container>
    <GetInTouch title="Get In Touch"
                text="You could be our next case study."
                buttonText="Let's talk"
                useBorderTop
                useArrow
    />
    <PageNavigation prev="capabilities" next="insights" />
  </Fragment>;
};

export default withRouter(VerizonHum);